import priority from "@/assets/images/Priority-ShortLogo-White.png";
import { eventsWithCountry, eventsWithTournament, ROUTES, eventsWithCity, eventsWithTeam } from "@/constants/routes";
export default {
  BRAND: "priority",
  BRAND_TITLE: "Priority",
  BRAND_SHORT_TITLE: "Priority",
  BRAND_ICON: "https://origin.priority.nl/favicon.ico", // fixme
  LOGO: priority,
  HIGHLIGHT_LOGO: priority,
  LOGO_MOBILE: priority,
  LOGO_FOOTER: priority,
  PORTAL_USER: "priority@xs2event.com",
  CURRENCY_OPTION: false,
  MOBILE_ONLY: false,
  PRIVACY: ROUTES.PRIVACY_POLICY,
  TERMS: ROUTES.TERMS,
  GENERAL_TERMS_LINK: ROUTES.GENERAL_TERMS_LINK,
  COMPANY_INFO: ROUTES.ABOUT,
  SPORT_TYPES: ["soccer"],
  WEBSITE: "https://www.priority.nl/",
  GA_ID: "G-G6814D6W5H",
  GTM_ID: "",
  //Content
  homepage_h1: "",
  homepage_p: "",
  homepage_title: "Official Football tickets",
  homepage_description: "",
  support_link: "https://xs2event.freshdesk.com",
  lang: ["nl"],
  routes: {
    sport_type: "events",
  },
  search: {
    params: {
      sport_type: "soccer",
    },
    categories: null,
    events: {},
    teams: {},
    tournaments: {},
    venues: {
      params: {
        sport_type: null,
        venue_type: "stadium",
      },
    },
  },
  menu: [
    {
      label: "England",
      region: "GBR",
      to: "",
      flyout_link: {
        label: "View all matches in England",
        to: eventsWithCountry("gbr"),
      },
      submenu: [
        { label: "Competitions", type: "tournaments", params: { sport_type: "soccer", region: "GBR" } },
        { label: "Popular teams", type: "popular-teams", params: { iso_country: "GBR", sport_type: "soccer" } },
        { label: "Popular matches", type: "popular-events", params: { country: "GBR", sport_type: "soccer" } },
      ],
    },
    {
      label: "Spain",
      to: "",
      region: "ESP",
      flyout_link: {
        label: "View all matches in Spain",
        to: eventsWithCountry("esp"),
      },
      submenu: [
        { label: "Competitions", type: "tournaments", params: { sport_type: "soccer", region: "ESP" } },
        { label: "Popular teams", type: "popular-teams", params: { iso_country: "ESP", sport_type: "soccer" } },
        { label: "Popular matches", type: "popular-events", params: { country: "ESP", sport_type: "soccer" } },
      ],
    },
    {
      label: "Italy",
      to: "",
      region: "ITA",
      flyout_link: {
        label: "View all matches in Italy",
        to: eventsWithCountry("ita"),
      },
      submenu: [
        { label: "Competitions", type: "tournaments", params: { sport_type: "soccer", region: "ITA" } },
        { label: "Popular teams", type: "popular-teams", params: { iso_country: "ITA", sport_type: "soccer" } },
        { label: "Popular matches", type: "popular-events", params: { country: "ITA", sport_type: "soccer" } },
      ],
    },
    {
      label: "France",
      to: "",
      region: "FRA",
      flyout_link: {
        label: "View all matches in France",
        to: eventsWithCountry("fra"),
      },
      submenu: [
        { label: "Competitions", type: "tournaments", params: { sport_type: "soccer", region: "FRA" } },
        { label: "Popular teams", type: "popular-teams", params: { iso_country: "FRA", sport_type: "soccer" } },
        { label: "Popular matches", type: "popular-events", params: { country: "FRA", sport_type: "soccer" } },
      ],
    },
    {
      label: "All matches",
      to: "/football",
    },
  ],
  featured: {
    block1: {
      photo: "premier-league/cover-photo",
      altText: "Premier league cover photo",
      to: eventsWithTournament("premier-league-2526"),
      title: "Premier League",
      tag: "Football",
      description: "",
      events_link: eventsWithTournament("premier-league-2526"),
      linktext: "View all tickets & events",
      linktextmobile: "Tickets & events",
    },
    block2: {
      photo: "fc-barcelona/cover-photo",
      altText: "FC Barcelona cover photo",
      to: eventsWithTeam("fc-barcelona"),
      title: "FC Barcelona",
      tag: "Football",
      description: "FC Barcelona",
      events_link: eventsWithTeam("fc-barcelona"),
      linktext: "View all available tickets",
      linktextmobile: "Available tickets",
    },
    block3: {
      photo: "celtic/cover-photo",
      photo: "coverphotos/celtic.jpg",
      altText: "Celtic FC cover photo",
      to: eventsWithTeam("celtic", { sport_type: "football" }),
      title: "Celtic FC",
      tag: "Football",
      events_link: eventsWithTeam("celtic", { sport_type: "football" }),
      linktext: "View all available tickets",
      linktextmobile: "Available tickets",
    },
    block4: {
      photo: "coverphotos/laliga.jpg",
      altText: "La Liga cover photo",
      to: eventsWithTournament("la-liga-2526"),
      title: "La Liga",
      tag: "Football",
      description: "",
      events_link: eventsWithTournament("la-liga-2526"),
      linktext: "View all tickets & events",
      linktextmobile: "Tickets & events",
    },
    block5: {
      photo: "voetbalzone/real-madrid.jpg",
      altText: "Real Madrid cover photo",
      to: eventsWithTeam("real-madrid"),
      title: "Real Madrid",
      tag: "Football",
      events_link: eventsWithTeam("real-madrid"),
      linktext: "View all available tickets",
      linktextmobile: "Available tickets",
    },
    block6: {
      photo: "coverphotos/werderbremen.jpg",
      altText: "Werder Bremen cover photo",
      to: eventsWithTeam("werder-bremen"),
      title: "Werder Bremen",
      tag: "Football",
      events_link: eventsWithTeam("werder-bremen"),
      linktext: "View all available tickets",
      linktextmobile: "Available tickets",
    },
  },
  quicklist: {
    params: {
      sport_type: "soccer",
    },
    cities: [
      { to: eventsWithCity("london"), label: "London" },
      { to: eventsWithCity("paris"), label: "Paris" },
      { to: eventsWithCity("barcelona"), label: "Barcelona" },
      { to: eventsWithCity("manchester"), label: "Manchester" },
      { to: eventsWithCity("milan"), label: "Milano" },
      { to: eventsWithCity("madrid"), label: "Madrid" },
      { to: eventsWithCity("liverpool"), label: "Liverpool" },
      { to: eventsWithCity("sevilla"), label: "Sevilla" },
      { to: eventsWithCity("bilbao"), label: "Bilbao" },
      { to: eventsWithCity("turin"), label: "Turin" },
    ],
    countries: [
      { to: eventsWithCountry("gbr"), label: "Great Britain" },
      { to: eventsWithCountry("esp"), label: "Spain" },
      { to: eventsWithCountry("ita"), label: "Italy" },
      { to: eventsWithCountry("fra"), label: "France" },
    ],
  },
  usps: [
    { text: "Thousands of tickets sold!" },
    { text: "Official tickets" },
    { text: "Easy to order" },
    { text: "Expert customer service" },
  ],
  footer: {
    contact: {
      support_mail: null,
      phone: null,
    },
    cols: [
      {
        title: "Klantenservice",
        content:
          'Heb je vragen over het bestellen van tickets voor een voetbalwedstrijd? Of wil je een voetbalwedstrijd bezoeken, maar heb je nog vragen over een bepaalde wedstrijd of wil je bijvoorbeeld met een grote groep gaan? Neem dan contact op met ons support team via email: <a href="mailto:priority@xs2event.com" class="underline" target="_blank">priority@xs2event.com</a> of bekijk onze FAQ pagina.',
        company_info: "",
        items: [{ name: "Contact" }, { name: "FAQ" }],
      },
    ],
    about: [
      {
        label: "General Terms and Conditions of XS2Event B.V.",
        href: ROUTES.GENERAL_TERMS_LINK,
      },
      { label: "Privacy statement", to: ROUTES.PRIVACY_POLICY },
      { label: "Corporate website", href: "https://www.xs2event.com" },
    ],
  },
};

export function getPriorityLoginUri() {
  // priority app will provide a JWT token in their request uri
  const params = new URLSearchParams(window.location.search);
  const orderKey = params.get("orderKey") ?? ""; // is the JWT token of priority

  return `/login?orderKey=${orderKey}`;
}

export function getBackUrl() {
  const params = new URLSearchParams(window.location.search);
  console.log(params);
  return params.get("backUrl") ?? "https://www.priority.nl/"; // is the JWT token of priority
}
